// NOTE: Adapted from: api/app/lib/checkout/calculate/jane_pay_service_fee_amount/get.rb
export const calculateJanePayFee = (
  total: number,
  fees?: {
    per_transaction: string | null;
    rate: string | null;
  }
) => {
  if (!fees) return 0;

  // Jane Pay added fee = (Original total + $ Per) / (1 - % Rate) - Original Total
  const base = (total + Number(fees.per_transaction)) / (1 - Number(fees.rate));
  return base - total;
};
